// ======================================================================
// File: src/modules/ipe/engineering/mom/EngineeringMOMView.js
// Purpose:
//   MOM view per Enquiry Item
//   - Displays MOM cards
//   - Similar pattern to RoutingView
// ======================================================================

import React from "react";
import MOMCard from "./MOMCard";

export default function EngineeringMOMView({ items = [] }) {

  return (

    <div>

      {items.length === 0 && (
        <div className="text-muted">
          No enquiry items available for MOM.
        </div>
      )}

      {items.map((item) => (

        <MOMCard
          key={item.id}
          item={item}
        />

      ))}

    </div>

  );

}